import store from './store';
const { profileInformation } = require('./user');

export const handleQuizProcess = async (data, element, callback) => {
  if (backEndVars.gptTransformQuiz) {
    data.profile = profileInformation();

    const quizAnswer = tracking.event({
      eventType: 'QuizAnswer',
      systemType: backEndVars.systemType,
      uri: window.location.pathname,
      domain: window.location.hostname,
      email: store.getAnswers()['saved-email'] || null,
      phone: store.get('__ph') || null,
      customerUuid: window.getCustomerUuid(),
      utmParams: store.getMarketingInfo('lastUtmParams'),
      additionalData: data,
    });

    await tracking.trackClient(quizAnswer);
  }
  callback(element);
};

export function getQuestion() {
  return document.querySelector('.js-quiz-question')?.textContent.trim() || '';
}

export function getSubtitle() {
  return document.getElementById('js-quiz-subtitle')?.textContent.trim() || '';
}

export function getSingleAnswer(element) {
  return {
    pageSequence: backEndVars.pageSequence,
    question: getQuestion(),
    subtitle: getSubtitle(),
    answer: {
      value: element.querySelector('.js-quiz-answer').textContent.trim(),
    },
  };
}

export function getMultiSelectedAnswer() {
  let selectedAnswers = [];
  const answers = document.querySelectorAll('.js-quiz-multi-answers:checked');

  // TODO this is temp while create new training design after that must be remove else statement
  answers.forEach(function (element) {
    if (element.type === 'checkbox') {
      const label = document.querySelector(`label[for="${element.id}"]`);
      selectedAnswers.push(label?.querySelector('.js-quiz-answer')?.textContent);
    } else {
      const parentButton = element.closest('.m-form-buttons__button');
      selectedAnswers.push(parentButton.querySelector('.js-quiz-answer').textContent);
    }
  });

  return {
    pageSequence: backEndVars.pageSequence,
    question: getQuestion(),
    subtitle: getSubtitle(),
    answer: {
      value: selectedAnswers.filter(Boolean).join(', ') || 'Continue',
    },
  };
}

export function getMeasurementsAnswer(inputFields) {
  let measurementsAnswer = {};

  inputFields.forEach(function (measurement) {
    measurementsAnswer[measurement.dataset.type] = measurement.value;
  });

  return {
    pageSequence: backEndVars.pageSequence,
    question: getQuestion(),
    subtitle: getSubtitle(),
    answer: measurementsAnswer,
  };
}
